import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { NetworkHelper } from '../helpers/network.helper';

@Injectable({
  providedIn: 'root',
})
export class TelegramBotService1 {
  readonly connectPoolTelegramUrl = environment.poolApi + '/user/telegram/verify';
  readonly connectMmsTelegramUrl = environment.mmsApi + '/user/verify-telegramid';

  constructor(private networkHelper: NetworkHelper) {}

  verifyPoolTelegramBot(code: string): Observable<boolean> {
    return this.networkHelper.post<boolean>(`${this.connectPoolTelegramUrl}`, { code });
  }

  verifyMmsTelegramBot(code: string): Observable<boolean> {
    return this.networkHelper.post<boolean>(`${this.connectMmsTelegramUrl}`, { code });
  }
}
